import script from "./ClassificationInformationsSelect2.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20ClassificationInformationSingleLevelBaseDto"
export * from "./ClassificationInformationsSelect2.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20ClassificationInformationSingleLevelBaseDto"

const __exports__ = script;

export default __exports__